import React from 'react';
import PropTypes from 'prop-types';

const QuizPagination = (props) => (
    <div className="quizPagination">
        <span className="quizPaginationInner">{String(props.index)}/{String(props.count)}</span>
    </div>
);

QuizPagination.propTypes = {
    index: PropTypes.number,
    count: PropTypes.number,
};

export default QuizPagination;



// WEBPACK FOOTER //
// ./src/campaign/challenges/quiz/quiz-pagination.jsx